import { BasicsClass } from '@/common/BasicsClass';
import { Util } from '@/common/util';

export class RoleVoiceManageAPI extends BasicsClass {
    public apiUrls: any = new Map([
        // ['forbideenRoleVoiceAccount', {
        //     url: '/user/forbid',
        //     name: 'account-forbid',
        //     label: '账户封禁'
        // }],
        ['getRoleVoiceTableList', {
            url: '/admin/voice/list',
            name: 'list',
            label: '列表'
        }],

        ['addRoleVoice', {
            url: '/admin/voice/add',
            name: 'add-role-voice',
            label: '添加角色语音'
        }],

        ['editRoleVoice', {
            url: '/admin/voice/edit',
            name: 'edit-role-voice',
            label: '编辑角色语音'
        }],

        ['delRoleVoice', {
            url: '/admin/voice/del',
            name: 'delete-role-voice',
            label: '删除角色语音'
        }],
        // ['getRoleVoiceDetail', {
        
        
        //     name: 'detail',
        //     label: '详情',
        //     // hidden: true
        // }]
    ])


    // // 角色语音列表
    public getRoleVoiceTableList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
      const apiUrls = this.apiUrls

      const url = apiUrls.get('getRoleVoiceTableList').url

      this.BasicPost(url, {
          ...params
      }, false, false, false, successCb, failCb, showLoading)
    }

    // // 添加角色语音
    public addRoleVoice(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
      const apiUrls = this.apiUrls

      const url = apiUrls.get('addRoleVoice').url

      this.BasicPost(url, {
          ...params
      }, false, false, false, successCb, failCb, showLoading)
    }

    // 编辑角色语音
    public editRoleVoice(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
      const apiUrls = this.apiUrls

      const url = apiUrls.get('editRoleVoice').url

      this.BasicPost(url, {
          ...params
      }, false, false, false, successCb, failCb, showLoading)
    }
    
    // 删除角色语音
    public delRoleVoice(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
      const apiUrls = this.apiUrls

      const url = apiUrls.get('delRoleVoice').url

      this.BasicPost(url, {
          ...params
      }, false, false, false, successCb, failCb, showLoading)
    }


}